var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwichRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.22969 4.52002L0.179688 8.31002V13.92C0.179688 14.88 1.33969 15.36 2.01969 14.68L7.19969 9.50002C8.02969 8.67002 8.02969 7.32002 7.19969 6.49002L5.22969 4.52002Z",
    fill: "#2E61D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.179688 2.07993V8.30993L5.22969 4.51993L2.01969 1.30993C1.33969 0.639927 0.179688 1.11993 0.179688 2.07993Z",
    fill: "#2E61D6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwichRight);
export default __webpack_public_path__ + "static/media/swich-right.e22b47499add6fca634f4db9eb7c2f62.svg";
export { ForwardRef as ReactComponent };